// extracted by mini-css-extract-plugin
export var container = "weekly-report-question-answers-module--container--1fcdd";
export var item = "weekly-report-question-answers-module--item--07a45";
export var questionIndex = "weekly-report-question-answers-module--question-index--1b62c";
export var title = "weekly-report-question-answers-module--title--12a2f";